export { default as ScalarPopover } from "./ScalarPopover.vue.js";
